<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="门店" v-if="isSa">
<!--                  <el-input style="width: 200px" v-model="queryForm.storeId"></el-input>-->
                  <GridSelectLi style="width: 200px" title="选择门店" labelName="storeName" labelValue="id"
                                :value="queryForm.storeId" :limit="1" size="small"
                                @getValue="getSearchValueShopId"
                                :columns="STORE_code" :searchs="STORE_search" dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get">
                  </GridSelectLi>
              </el-form-item>
              <el-form-item label="分类名称">
                  <el-input style="width: 200px" v-model="queryForm.categoryName"></el-input>
              </el-form-item>
<!--              <el-form-item label="是否必选">-->
<!--                  <el-select-->
<!--                      v-model="queryForm.isRequired"-->
<!--                      size="small"-->
<!--                      placeholder="请选择是否必选"-->
<!--                      clearable-->
<!--                      style="width: 200px"-->
<!--                  >-->
<!--                      <el-option label="是" :value="1"> </el-option>-->
<!--                      <el-option label="否" :value="0"> </el-option>-->
<!--                  </el-select>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="是否显示">-->
<!--                  <el-select-->
<!--                      v-model="queryForm.isShow"-->
<!--                      size="small"-->
<!--                      placeholder="请选择是否显示"-->
<!--                      clearable-->
<!--                      style="width: 200px"-->
<!--                  >-->
<!--                      <el-option label="是" :value="1"> </el-option>-->
<!--                      <el-option label="否" :value="0"> </el-option>-->
<!--                  </el-select>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreTakeoutProductCategoryList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopStoreTakeoutProductCategory"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopStoreTakeoutProductCategory(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStoreTakeoutProductCategory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportShopStoreTakeoutProductCategoryList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopStoreTakeoutProductCategoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopStoreTakeoutProductCategoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="storeId"-->
<!--        label="门店信息"-->
<!--        width="180"-->
<!--      >-->
<!--          <template slot-scope="scope">-->
<!--              <div v-if='scope.row.store'-->
<!--                   style="display: flex;justify-content: center;align-items: center;">-->
<!--                  <el-image @click='updateSrcList(scope.row.store.storeLogo)' style="width: 60px; height: 60px"-->
<!--                            :src="scope.row.store.storeLogo" :preview-src-list="srcList"></el-image>-->
<!--                  <div style="flex:auto;text-align: center;margin-left: 4px;">-->
<!--                      <div>{{ scope.row.store.storeName }}</div>-->
<!--                      <div :style="{'fontSize':'12px',color:scope.row.store.openStatus == 1 ? 'green':'red'}">-->
<!--                          ({{ scope.row.store.openStatus == 1 ? '正常营业' : '暂停营业' }})-->
<!--                      </div>-->
<!--                      <div>{{ scope.row.store.openHours }}</div>-->
<!--                      &lt;!&ndash;                                <div>收益比列：{{ scope.row.incomeRatio }}</div>&ndash;&gt;-->
<!--                  </div>-->
<!--              </div>-->
<!--              <div v-else>&#45;&#45;</div>-->
<!--          </template>-->
<!--      </el-table-column>-->
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            v-if="isSa"
            prop="storeId"
            label="门店ID"
            width="180"
        > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryName"
        label="分类名称"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="categoryDesc"-->
<!--        label="分类描述"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="categoryPic"-->
<!--        label="分类图片"-->
<!--        width="180"-->
<!--      >-->
<!--          <template slot-scope="scop">-->
<!--              <el-image-->
<!--                  @click='updateSrcList(scop.row.categoryPic)'-->
<!--                  style="width: 30px; height: 30px"-->
<!--                  :src="scop.row.categoryPic"-->
<!--                  :preview-src-list="srcList"-->
<!--              > </el-image>-->
<!--          </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="isRequired"-->
<!--        label="是否必选"-->
<!--        width="180"-->
<!--      >-->
<!--          <template slot-scope="scop">-->
<!--              {{scop.row.isRequired == 1 ? '是' : '否'}}-->
<!--          </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="parentId"-->
<!--        label="父类"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--        <el-table-column-->
<!--            :show-overflow-tooltip="true"-->
<!--            align="center"-->
<!--            prop="isShow"-->
<!--            label="是否显示"-->
<!--            width="180"-->
<!--        >-->
<!--            <template slot-scope="scop">-->
<!--                {{scop.row.isShow == 1 ? '是' : '否'}}-->
<!--            </template>-->
<!--        </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      >
          <template slot-scope="scop">
              <el-input-number
                  style="width:150px"
                  v-model="scop.row.sort"
                  @change="changeSort(scop.row)"
                  size="small"
                  label=""
                  :min="1"
                  :max="1000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopStoreTakeoutProductCategory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopStoreTakeoutProductCategory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopStoreTakeoutProductCategory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopStoreTakeoutProductCategoryStates[shopStoreTakeoutProductCategoryState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopStoreTakeoutProductCategory"
          ref="shopStoreTakeoutProductCategoryForm"
          :rules="rules"
          label-width="80px"
          size="small"
        >
          <el-form-item
            label="门店"
            prop="storeId"
            v-if="isSa"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStoreTakeoutProductCategory.storeId"-->
<!--              :disabled="shopStoreTakeoutProductCategoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectLi style="width: 250px" title="选择门店" labelName="storeName" labelValue="id" :disabled="shopStoreTakeoutProductCategoryState == 'check'"
                            :value="shopStoreTakeoutProductCategory.storeId" :limit="1" size="small"
                            @getValue="getValueShopId"
                            :columns="STORE_code" :searchs="STORE_search" dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get">
              </GridSelectLi>
          </el-form-item>
          <el-form-item
            label="分类名称"
            prop="categoryName"
          >
            <el-input
              size="small"
              style="width: 250px"
              v-model="shopStoreTakeoutProductCategory.categoryName"
              :disabled="shopStoreTakeoutProductCategoryState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="分类描述"-->
<!--            prop="categoryDesc"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 250px"-->
<!--              v-model="shopStoreTakeoutProductCategory.categoryDesc"-->
<!--              :disabled="shopStoreTakeoutProductCategoryState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="分类图片"-->
<!--            prop="categoryPic"-->
<!--          >-->
<!--              <el-upload-->
<!--                  action=""-->
<!--                  :disabled="shopStoreTakeoutProductCategoryState == 'check'"-->
<!--                  class="avatar-uploader"-->
<!--                  :show-file-list="false"-->
<!--                  :http-request="uploadAvatar"-->
<!--                  style="width: 200px"-->
<!--              >-->
<!--                  <img-->
<!--                      v-if="shopStoreTakeoutProductCategory.categoryPic"-->
<!--                      :src="shopStoreTakeoutProductCategory.categoryPic"-->
<!--                      class="avatar"-->
<!--                  />-->
<!--                  <i-->
<!--                      v-else-->
<!--                      class="el-icon-plus avatar-uploader-icon"-->
<!--                  ></i>-->
<!--              </el-upload>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="是否必选"-->
<!--            prop="isRequired"-->
<!--          >-->
<!--              <el-select-->
<!--                  v-model="shopStoreTakeoutProductCategory.isRequired"-->
<!--                  :disabled="shopStoreTakeoutProductCategoryState == 'check'"-->
<!--                  size="small"-->
<!--                  placeholder="请选择是否必选"-->
<!--                  clearable-->
<!--                  style="width: 250px"-->
<!--              >-->
<!--                  <el-option label="是" :value="1"> </el-option>-->
<!--                  <el-option label="否" :value="0"> </el-option>-->
<!--              </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="父类"-->
<!--            prop="parentId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStoreTakeoutProductCategory.parentId"-->
<!--              :disabled="shopStoreTakeoutProductCategoryState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--            <el-form-item-->
<!--            label="是否显示"-->
<!--            prop="isShow"-->
<!--          >-->
<!--                <el-select-->
<!--                    v-model="shopStoreTakeoutProductCategory.isShow"-->
<!--                    :disabled="shopStoreTakeoutProductCategoryState == 'check'"-->
<!--                    size="small"-->
<!--                    placeholder="请选择是否显示"-->
<!--                    clearable-->
<!--                    style="width: 250px"-->
<!--                >-->
<!--                    <el-option label="是" :value="1"> </el-option>-->
<!--                    <el-option label="否" :value="0"> </el-option>-->
<!--                </el-select>-->
<!--          </el-form-item>-->
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStoreTakeoutProductCategory.sort"-->
<!--              :disabled="shopStoreTakeoutProductCategoryState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 250px"
                  :disabled="shopStoreTakeoutProductCategoryState == 'check'"
                  v-model="shopStoreTakeoutProductCategory.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopStoreTakeoutProductCategoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exportExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { STORE, STORE_SEARCH } from '@/utils/constant';
import GridSelectLi from '@/components/gridselect/gidselect.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectLi
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStoreTakeoutProductCategoryList();
                    this.getShopStoreTakeoutProductCategoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStoreTakeoutProductCategoryList();
                    this.getShopStoreTakeoutProductCategoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     storeId: '', //门店ID
                     categoryName: '', //分类名称
                     categoryDesc: '', //分类描述
                     categoryPic: '', //分类图片
                     isRequired: '', //是否必选
                     parentId: '', //父类
                     sort: '', //排序
                    isShow: '', //是否显示
                },
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                srcList: [''],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStoreTakeoutProductCategoryState: 'add',
                shopStoreTakeoutProductCategoryStates: {
                    add: '新建外卖分类',
                    check: '查看外卖分类',
                    edit: '修改外卖分类'
                },

                multipleSelection: [],
                shopStoreTakeoutProductCategoryList: [],
                shopStoreTakeoutProductCategory: {
                    id: '', //
                    storeId: '', //门店ID
                    categoryName: '', //分类名称
                    categoryDesc: '', //分类描述
                    categoryPic: '', //分类图片
                    isRequired: '', //是否必选
                    parentId: '', //父类
                    sort: '', //排序
                    isShow: '',
                },
                btnLoading: false,

                rules: {
                    storeId: [{ required: true, message: '门店ID不能为空', trigger: 'blur' }],
                    categoryName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
                    categoryDesc: [{ required: true, message: '分类描述不能为空', trigger: 'blur' }],
                    categoryPic: [{ required: true, message: '分类图片不能为空', trigger: 'blur' }],
                    isRequired: [{ required: true, message: '是否必选不能为空', trigger: 'blur' }],
                    parentId: [{ required: true, message: '父类不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    isShow: [{ required: true, message: '是否显示不能为空', trigger: 'blur' }]
                },
                isSa: 0,
            };
        },
        created() {
            this.getIsSa();
            this.getShopStoreTakeoutProductCategoryList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getIsSa(){
                get('/mpp/user/getIsSa').then(res=>{
                    if(res.success){
                        this.isSa=res.isSa;
                    }
                })
            },
            getSearchValueShopId(value) {
                this.queryForm.storeId = value
            },
            getValueShopId(value) {
                this.shopStoreTakeoutProductCategory.storeId = value
            },
            changeSort(category) {
                console.log('1111111',category);
                delete category.products;
                post(`/shop/storetakeoutproductcategory/edit`,{ ...category }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: `编辑成功`,
                            type: 'success',
                            duration: 2000
                        });
                        this.getShopStoreTakeoutProductCategoryList();

                    }
                });
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.shopStoreTakeoutProductCategory.categoryPic = res.url;
                    }
                });
            },
            updateSrcList(src){
                this.srcList[0] = src
            },
            resetShopStoreTakeoutProductCategoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStoreTakeoutProductCategoryList = [];
            },
            resetDialog() {
                this.shopStoreTakeoutProductCategoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      storeId: '', //门店ID
                      categoryName: '', //分类名称
                      categoryDesc: '', //分类描述
                      categoryPic: '', //分类图片
                      isRequired: '', //是否必选
                      parentId: '', //父类
                      sort: '', //排序
                      isShow: '',
                };
                this.getShopStoreTakeoutProductCategoryList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopStoreTakeoutProductCategory = {
                      id: '', //
                      storeId: '', //门店ID
                      categoryName: '', //分类名称
                      categoryDesc: '', //分类描述
                      categoryPic: '', //分类图片
                      isRequired: '', //是否必选
                      parentId: '', //父类
                      sort: '', //排序
                      isShow: '',
                };
            },
            submitForm() {
                if (this.shopStoreTakeoutProductCategoryState == 'add') {
                    this.$refs.shopStoreTakeoutProductCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storetakeoutproductcategory/add`,{ ...this.shopStoreTakeoutProductCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopStoreTakeoutProductCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopStoreTakeoutProductCategoryState == 'edit') {
                    this.$refs.shopStoreTakeoutProductCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopStoreTakeoutProductCategory.products
                            post(`/shop/storetakeoutproductcategory/edit`,{ ...this.shopStoreTakeoutProductCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStoreTakeoutProductCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopStoreTakeoutProductCategory() {
                this.showDialog = true;
                this.shopStoreTakeoutProductCategoryState = 'add';
            },
            checkShopStoreTakeoutProductCategory(shopStoreTakeoutProductCategoryId) {
                console.log(shopStoreTakeoutProductCategoryId);
                this.currentShopStoreTakeoutProductCategoryId = shopStoreTakeoutProductCategoryId;

                this.getShopStoreTakeoutProductCategoryById();
                this.showDialog = true;
                this.shopStoreTakeoutProductCategoryState = 'check';
            },
            editShopStoreTakeoutProductCategory(shopStoreTakeoutProductCategoryId) {
                console.log('shopStoreTakeoutProductCategory', shopStoreTakeoutProductCategoryId);
                if (shopStoreTakeoutProductCategoryId) {
                    this.currentShopStoreTakeoutProductCategoryId = shopStoreTakeoutProductCategoryId;
                    this.getShopStoreTakeoutProductCategoryById();
                } else {
                    this.shopStoreTakeoutProductCategory = { ...this.shopStoreTakeoutProductCategory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStoreTakeoutProductCategoryState = 'edit';
            },
            deleteShopStoreTakeoutProductCategory(shopStoreTakeoutProductCategoryId) {
                let ids = '';
                if (shopStoreTakeoutProductCategoryId) {
                    ids = shopStoreTakeoutProductCategoryId;
                } else {
                    ids = this.multipleSelection.map((shopStoreTakeoutProductCategory) => shopStoreTakeoutProductCategory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storetakeoutproductcategory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreTakeoutProductCategoryList();
                                this.getShopStoreTakeoutProductCategoryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStoreTakeoutProductCategoryList() {
                this.resetShopStoreTakeoutProductCategoryList();
                this.getShopStoreTakeoutProductCategoryList();
            },
            getShopStoreTakeoutProductCategoryList(query = {}) {
                this.loading = true;
                get(`/shop/storetakeoutproductcategory/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStoreTakeoutProductCategoryList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStoreTakeoutProductCategoryById() {
                get(`/shop/storetakeoutproductcategory/get`,{ id: this.currentShopStoreTakeoutProductCategoryId }).then((res) =>{
                    if(res.success){
                      this.shopStoreTakeoutProductCategory = { ...this.shopStoreTakeoutProductCategory, ...res.shopStoreTakeoutProductCategory };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStoreTakeoutProductCategoryList() {
                //this.btnLoading = true;
                exportExcel(`/shop/storetakeoutproductcategory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storetakeoutproductcategory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storetakeoutproductcategory/importData`,formData);
              this.refreshShopStoreTakeoutProductCategoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStoreTakeoutProductCategoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStoreTakeoutProductCategoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>